import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { ServiceBase } from './service-base';
import { IPronounSelectItemModel } from './interfaces/select-item.interface';

@Injectable({ providedIn: 'root' })
export class PronounService extends ServiceBase {
  private static readonly ApiUrl = 'api/pronoun';

  private selectItems$?: Observable<IPronounSelectItemModel[]>;

  constructor(private http: HttpClient) {
    super();
  }

  public get(): Observable<IPronounSelectItemModel[]> {
    return this.http.get<IPronounSelectItemModel[]>(PronounService.ApiUrl);
  }

  public getSelectItems(): Observable<IPronounSelectItemModel[]> {
    if (!this.selectItems$) {
      const url = `${PronounService.ApiUrl}/list`;

      this.selectItems$ = this.http.get<IPronounSelectItemModel[]>(url).pipe(
        shareReplay({ bufferSize: 1, refCount: true })
      );
    }

    return this.selectItems$;
  }
}
